import React from "react";
import { Button } from "../../components/Button/Button";
import { PurchaseRequestStatusEnum } from "../../schema";
import { DrawingItemLike, hasProductCode } from "./drawingSearchPresentation";
import styles from "./DrawingsButton.module.scss";

export interface DrawingsButtonProps {
  drawingsEnabled: boolean;
  status: PurchaseRequestStatusEnum;
  items: DrawingItemLike[];
  loading: boolean;
  onClick(): void;
}

export const DrawingsButton: React.FC<DrawingsButtonProps> = ({
  drawingsEnabled,
  status,
  items,
  loading,
  onClick,
}) => {
  if (!drawingsEnabled || status !== PurchaseRequestStatusEnum.DRAFT) {
    return null;
  }

  return (
    <Button
      quaternary
      className={styles["drawings-button"]}
      disabled={!hasProductCode(items) || loading}
      loading={loading}
      onClick={onClick}
    >
      Drawings
    </Button>
  );
};
